import styled from '@emotion/styled';
import UnstyledButton from '@embed/components/common/UnstyledButton';
export const CloseIconButton = styled(UnstyledButton) `
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;

  span {
    color: black;
  }
`;
export const SharePanelOptionWrapper = styled.div `
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: space-between;
  margin: 0 12px;
  width: auto;

  > a,
  button {
    min-width: 80px;
  }
`;
